exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EditRouteDialog-81fc2200 .cols-23f90754{display:flex}.EditRouteDialog-81fc2200 .col1-a5608c1b{flex:1;margin-right:40px}.EditRouteDialog-81fc2200 .col2-1a703a19{flex:1}\n", ""]);

// Exports
exports.locals = {
	"EditRouteDialog": "EditRouteDialog-81fc2200",
	"cols": "cols-23f90754",
	"col1": "col1-a5608c1b",
	"col2": "col2-1a703a19"
};